import DocumentTranslator from "./DocumentTranslator";
import TextTranslator from "./TextTranslator";
import GlossaryTable from "./GlossaryTable";
import { useNavigate } from "react-router-dom";
import { Button } from "semantic-ui-react";
import UserAdministration from "./UserAdministration";
import { axiosInstance } from "../../fetcher";

const Translator = ({ isAdmin }) => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    navigate("/login");
  };

  const handleChangePassword = async () => {
    const newPassword = prompt("Enter new password:");
    const confirmPassword = prompt("Confirm new password:");
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d@$!%*#?&]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      alert(
        "Password must be at least 8 characters long, contain one uppercase letter and one special character."
      );
      return;
    }

    try {
      const response = await axiosInstance.put("/auth/update-user", {
        password: newPassword,
      });
      if (response.status === 200) {
        alert("Password changed successfully!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="pills-home-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-home"
              type="button"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
            >
              <i className="file icon"></i>
              <b>Text Translator</b>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-profile"
              type="button"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
            >
              <i className="language icon"></i>

              <b>Document Translator</b>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-contact-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-contact"
              type="button"
              role="tab"
              aria-controls="pills-contact"
              aria-selected="false"
            >
              <i className="book icon"></i>
              <b> Glossary</b>
            </button>
          </li>

          {isAdmin && (
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-admin-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-admin"
                type="button"
                role="tab"
                aria-controls="pills-admin"
                aria-selected="false"
              >
                <i className="user icon"></i>
                <b>User Administration</b>
              </button>
            </li>
          )}
          <li
            className="nav-link"
            id="pills-change-password-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-change-password"
            type="button"
            role="tab"
            onClick={handleChangePassword}
            aria-controls="pills-change-password"
            aria-selected="false"
          >
            <i className="key icon"></i>
            <b>Change Password</b>
          </li>
        </ul>
        <Button color="red" onClick={handleSignOut}>
          Sign Out
        </Button>
      </div>
      <div className="tab-content" id="pills-tabContent">
        <div
          className="tab-pane fade show active"
          id="pills-home"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
          tabIndex="0"
        >
          <TextTranslator />
        </div>
        <div
          className="tab-pane fade"
          id="pills-profile"
          role="tabpanel"
          aria-labelledby="pills-profile-tab"
          tabIndex="1"
        >
          <DocumentTranslator />
        </div>
        <div
          className="tab-pane fade"
          id="pills-contact"
          role="tabpanel"
          aria-labelledby="pills-contact-tab"
          tabIndex="2"
        >
          <GlossaryTable />
        </div>
        {isAdmin && (
          <div
            className="tab-pane fade"
            id="pills-admin"
            role="tabpanel"
            aria-labelledby="pills-admin-tab"
            tabIndex="3"
          >
            <UserAdministration />
          </div>
        )}
      </div>

      <div
        className="tab-pane fade"
        id="pills-change-password"
        role="tabpanel"
        aria-labelledby="pills-change-password-tab"
        tabIndex="4"
      ></div>
    </>
  );
};

export default Translator;
